import React from 'react';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Container from 'components/Container';

const mock = [
  {
  field: 'Medical Course',
  },
  {
    name: 'SALONI JHA',
    email: 'MBBS',
    title: 'MYSORE MEDICAL COLLEGE AND RESEARCH INSTITUTE  ',    
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  {
    name: 'MEDHA PAREKODI BHAT ',
    email: 'MBBS',
    title: 'RAMAIAH MEDICAL COLLEGE',    
   
    // status: '10',
    // role: 'English-88.00% A',
    
  },
  
 {
    field: 'Engineering Courses',
  },
  {
    name: 'DISHA M. BHAT ',
    email: 'ENGINEERING IN COMPUTER SCIENCE ',
    title: 'R V COLLEGE OF ENGINEERING ',
  
  },

  {
    name: 'SAKET RAMCHANDRA ',            
    email: 'DUAL DEGREE IN MSC MATHEMATICS AND BTECH',                            
    title: 'BIRLA INSTITUTE OF TECHNOLOGY AND SCIENCE ',                            
  
  },
  {
    name: ' MILIND JOISA',
    email: 'DUAL DEGREE IN BACHELOR OF ENGINEERING AND MASTER OF SCIENCE IN ECONOMICS',
    title: 'BIRLA INSTITUTE OF TECHNOLOGY AND SCIENCE PILANI',
  
  },
  {
    name: 'ARTHUR LESLIE',
    email: 'MECHANICAL ENGINEERING WITH MINOR IN COMPUTER SCIENCE ENGINEERING ',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY, VELLORE',
  
  },
  {
    name: 'HARSH BHATT ',
    email: 'B. TECH COMPUTER SCIENCE AND ENGINEERING ',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY ',
  
  },
  {
    name: 'JEEVAN P ABRAHAM',
    email: 'B TECH COMPUTER SCIENCE ENGINEERING (BIOINFORMATICS)',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY',
  
  },
  {
    name: 'SOORYA ANVEKAR NATARAJAN ',
    email: 'COMPUTER SCIENCE AND ENGINEERING - DATA SCIENCE',
    title: 'RV COLLEGE OF ENGINEERING',
  
  },
  {
    name: 'TUSHAR A D RAO ',
    email: 'MECHATRONICS',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY, MANIPAL',
  
  },
  {
    name: '  ANIRUDH RAGHAVAN ',
    email: 'BTECH MECHANICAL ENGINEERING ',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY',
  
  },
  {
    name: 'R.TUSHTI',
    email: 'B.E. IN AEROSPACE ENGINEERING ',
    title: 'R V COLLEGE OF ENGINEERING ',
  
  },
  {
    name: 'RUTHVIK B V ',
    email: 'ELECTRONICS AND COMMUNICATION ENGINEERING ',
    title: 'PEOPLES EDUCATION SOCIETY UNIVERSITY(PESU)',
  
  },
  {
    name: 'DHIMAHI RAI',
    email: 'COMPUTER SCIENCE AND BUSINESS SYSTEM',
    title: 'BMS INSTITUTE OF TECHNOLOGY & MANAGEMENT',
  
  },
  {
    name: 'KRITIKA P',
    email: 'COMPUTER SCIENCE AND ENGINEERING',
    title: 'SAI VIDYA INSTITUTE OF TECHNOLOGY',
  
  },
  {
    name: 'TARUN BALAJI RAO',
    email: 'AUTOMOTIVE ENGINEERING ',
    title: 'M S RAMIAH UNIVERSITY OF APPLIED SCIENCES',
  
  },
  {
    name: 'RISHIL N ',
    email: 'B.TECH COMPUTER SCIENCE (INFORMATION TECHNOLOGY)',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY (VIT)',
  
  },
  {
    name: 'SIDDHARTH SUDHEER ',
    email: 'BTECH MECHANICAL ENGINEERING ',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY ',
  
  },
  {
    name: 'ADITYA G TANKASALI ',
    email: 'COMPUTER SCIENCE AND ENGINEERING ',
    title: 'DAYANAND SAGAR COLLEGE OF ENGINEERING ',
  
  },
  {
    name: 'SASHA SUSAN ABRAHAM',
    email: 'BACHELOR OF TECHNOLOGY HONOURS IN COMPUTER SCIENCE',
    title: 'RV UNIVERSITY',
  
  },
  {
    name: 'JAIVEER SHARMA',
    email: 'B TECH CSE',
    title: 'AMITY UNIVERSITY',
  
  },
  {
    name: 'SRIKARAN SRIVATSAN',
    email: 'COMPUTER SCIENCE AND ENGINEERING',
    title: 'PRESIDENCY UNIVERSITY',
  
  },
  {
    name: 'PARAM CHAUDHARY ',
    email: 'MECHANICAL ENGINEERING ',
    title: 'VELLORE INSTITUTE OF TECHNOLOGY ',
  
  },
  {
    name: 'KUKKADAPU SAI HAVISH',
    email: 'B Tech COMPUTER SCIENCE (Honors)',
    title: 'RV UNIVERSITY ',
  
  },
  {
    name: 'HARSH GANDHI ',
    email: 'COMPUTERS AND COMMUNICATION ENGINEERING ',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY, MANIPAL',
  },
  {
    name: 'ISHANIKA S',
    email: 'BACHELOR OF ENGINEERING IN COMPUTER SCIENCE- AI & ML',
    title: 'SAPTHAGIRI NPS UNIVERSITY ',
  
  },
  {
    name: 'ADHYA',
    email: 'BE Computer Science',
    title: 'RV UNIVERSITY',
  
  },
  {
    name: 'VARSHA LOKESH',
    email: 'B Tech(CS)',
    title: 'RV UNIVERSITY',
  
  },
  {
    name: 'SAI SHRUTI RAY',
    email: 'BE (ECE)',
    title: 'SIR M. VISVESVARAYA INSTITUTE OF TECHNOLOGY',
  
  },
  {
    name: 'DHYEY ABHAY GHODA',
    email: 'B Tech(CS) Hons.',
    title: 'RV UNIVERSITY',
  
  },
  {
    name: 'KHUSH BHOJNAGARWALA',
    email: 'BE(EEE)',
    title: 'MANIPAL INSTITUTE OF TECHNOLOGY ',
  
  },
  {
    name: 'CHITRANGADA SHARMA',
    email: 'B.ARCH',
    title: 'WADIYAR CENTRE FOR ARCHITECTURE',
  
  },
  {
    name: 'D TANVI',
    email: 'BACHELOR OF ARCHITECTURE ',
    title: 'WADIYAR CENTRE FOR ARCHITECTURE',
  
  },
  {
    name: 'CHUDISHTA D',
    email: 'BACHELOR OF ARCHITECTURE ',
    title: 'BMS COLLEGE OF ARCHITECTURE',
  
  },
  {
    name: 'LAHARI D',
    email: 'B.ARCH/ARCHITECTURE ',
    title: 'BMS COLLEGE OF ARCHITECTURE',
  
  },

  {
    field: 'Other Professional Courses',
   },
   {
     name: 'AARYA DESHPANDE',
     email: 'BACHELOR OF COMMERCE IN INTERNATIONAL FINANCE CFA INTERGRATED ',
     title: 'CHRIST UNIVERSITY CENTRAL CAMPUS ',
    
   },
   {
     name: 'URSHITA',
     email: 'CHARTERED ACCOUNTANT',
     title: 'DELHI UNIVERSITY ',
     
   },
   {
     name: 'ANJALI PITLIYA',
     email: 'BCOM PROFESSIONAL WITH CA ',
     title: 'MOUNT CARMEL COLLEGE AUTONOMOUS ',
     
   },
   {
     name: 'VAISHNAVI ALVA',
     email: 'BBA LLB (H) - LAW',
     title: 'CHRIST (DEEMED TO BE) UNIVERSITY, CENTRAL CAMPUS',
   
   },
   {
     name: 'PRIYANKA M VALECHA ',
     email: 'BSC EMS( ECONOMICS , MATHS, STATS)',
     title: 'CHRIST ( DEEMED TO BE UNIVERSITY )',
   
   },
   {
     name: 'SHASHANK B KOUNDINYA ',
     email: 'CHRIST UNIVERSITY ',
     title: 'B.COM (CA-INTEGRATED) ',
   
   },
   {
     name: 'RISHI DUDANI',
     email: 'BACHELOR OF BUSINESS MANAGEMENT IN FINANCE AND MARKETING ANALYTICS ',
     title: 'CHRIST DEEMED TO BE UNIVERSITY BENGALURU',
   
   },
   {
     name: 'MAHATVA SHARMA ',
     email: 'BACHELOR OF BUSINESS ADMINISTRATION ',
     title: 'CHRIST UNIVERSITY ',
   
   },
   {
     name: 'VARSHINI',
     email: 'BACHELORS OF ARCHITECTURE ',
     title: 'BMS COLLEGE OF ARCHITECTURE,BANGALORE',
   
   },
   {
     name: 'THARUN K RAM',
     email: 'BCOM INTERNATIONAL ACCOUNTS AND FINANCE',
     title: 'CHRIST UNIVERSITY CENTRAL CAMPUS',
   
   },
   {
     name: 'YUKTI SETHIA ',
     email: 'BSC. BIOTECHNOLOGY (HONORS)',
     title: 'M.S. RAMAIAH UNIVERSITY OF APPLIED SCIENCES ',
   
   },
   {
     name: 'RUCHA SHASHIN SHOBHANE ',
     email: 'B Sc. BIOTECHNOLOGY ',
     title: 'SHIV NADAR INSTITUTE OF EMINENCE',
   
   },
   {
     name: 'AKSHAY SATHISH',
     email: 'BA.LLB',
     title: 'SYMBIOSIS LAW SCHOOL PUNE',
   
   },
   {
     name: 'ADHVAITH JAISHANKAR ',
     email: 'BACHELORS OF BUSINESS ADMINISTRATION (STRATEGY AND BUSINESS ANALYTICS)',
     title: 'CHRIST UNIVERSITY YESHWANTPUR ',
   
   },
   {
     name: 'PARTH PURUSHOTTAM DEWANG',
     email: 'B. COM',
     title: 'CHRIST UNIVERSITY',
   
   },
   {
     name: 'MANAVI KHANNA ',
     email: 'LIBERAL ARTS ',
     title: 'KREA UNIVERSITY ',
   
   },
   {
     name: 'ADITI NARAYAN ',
     email: 'BBA LLB (Hons) ',
     title: 'OP JINDAL GLOBAL UNIVERSITY ',
   
   },
   {
     name: 'SAMARTH K',
     email: ' BSC (ECONOMICS)',
     title: 'CHRIST COLLEGE',
   
   },
   {
     name: 'VYSHNAV V KASHYAP',
     email: 'BSC IN COMPUTER SCIENCE',
     title: 'CANADIAN UNIVERSITY',
   
   },
   {
     name: 'LOKRANJAN B GOWDA',
     email: ' BCOM (ACCA)',
     title: 'MIT',
   
   },
   {
     name: 'ANSHU K',
     email: 'BACHELOR OF DESIGN ',
     title: 'RV UNIVERSITY ',
   
   },
   {
     name: 'TANISH PUTHRAN',
     email: 'B COM.(WITH INT CA)',
     title: 'JAIN UNIVERSITY , JAYANAGAR',
   
   },
   
];

 const Simple = () => {
  const theme = useTheme();
  return (
   
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 200 }} aria-label="simple table">
         
          <TableBody>
            {mock.map((item, i) => (
              <TableRow
                key={i}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                <Typography
                  align='left'
                  variant={'h6'}
                  fontWeight={600}
                  color={'blue'}
                >
                  {item.field}
                </Typography>
                  <Typography variant={'subtitle2'} fontWeight={700}>
                    {item.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.email}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.title}
                  </Typography>
                </TableCell>
               
           
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

  );
};

export default Simple;